import { c as _c } from "react/compiler-runtime";
import { fetchSlides } from '@/lib/api';
import HomeSliderSwiper from './home-slider-swiper';
const HomeSlider = async () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = await fetchSlides();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const items = t0;
  if (items.length < 1) {
    return;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HomeSliderSwiper items={items} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default HomeSlider;